import { useQuery } from "@tanstack/react-query";
import { integrationService } from "../services/integrationService";

const useIntegrationKeys = () => {
  return useQuery({ queryKey: ["integration-keys"], queryFn: () => integrationService.listKeys() });
};

export default useIntegrationKeys;
